import { Images } from 'constants';
import React, { useEffect, useState } from 'react'

const Footer = ({ wplink }) => {
    const [show_whatsapp, setShowWTSP] = useState(true)
    const [isDragging, setIsDragging] = useState(false);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });


    const onMouseDown = (e) => {
        e.preventDefault();
        setDragStart({
            x: e.clientX - position.x,
            y: e.clientY - position.y,
        });
        setIsDragging(true);
    };

    const onTouchStart = (e) => {
        e.preventDefault();
        const touch = e.touches[0];
        setDragStart({
            x: touch.clientX - position.x,
            y: touch.clientY - position.y,
        });
        setIsDragging(true);
    };

    const onMouseMove = (e) => {
        if (isDragging) {
            const newX = e.clientX - dragStart.x;
            const newY = e.clientY - dragStart.y;
            setPosition({ x: newX, y: newY });
        }
    };

    const onTouchMove = (e) => {
        if (isDragging) {
            const touch = e.touches[0];
            const newX = touch.clientX - dragStart.x;
            const newY = touch.clientY - dragStart.y;
            setPosition({ x: newX, y: newY });
        }
    };

    const onMouseUp = () => {
        setIsDragging(false);
    };

    const onTouchEnd = () => {
        setIsDragging(false);
    };

    const preventScroll = (e) => {
        if (isDragging) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        if (isDragging) {
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
            document.addEventListener('touchmove', onTouchMove);
            document.addEventListener('touchend', onTouchEnd);
            // Remove the scroll preventers
            document.removeEventListener('wheel', preventScroll);
            document.removeEventListener('touchmove', preventScroll);
        } else {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
            // Remove the scroll preventers
            document.removeEventListener('wheel', preventScroll);
            document.removeEventListener('touchmove', preventScroll);
        }

        return () => {
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
            document.removeEventListener('touchmove', onTouchMove);
            document.removeEventListener('touchend', onTouchEnd);
            document.removeEventListener('wheel', preventScroll);
            document.removeEventListener('touchmove', preventScroll);

        };
    }, [isDragging]);


    return (
        <React.Fragment>
            <div className='footer flex justify-center items-center w-full sm:w-[390px] mt-2'>
                <div className='footer-inner'>
                    <div className="flex justify-center items-center">
                        <div>
                            <div className={'flex items-center justify-between w-full footer-links '}>
                                <a href="/rules" style={{ pointerEvents: "none" }}>Rules</a>
                                <a href="#" style={{ pointerEvents: "none" }}>Privacy Policy</a>
                                <a href="/rules" style={{ pointerEvents: "none" }}>Terms & Conditions</a>
                            </div>
                            <div className='footer-hr mt-4'></div>
                            <div className="text-center py-2 px-4 mt-2 fborder-t">
                                <p className={'footer-description '}>
                                    This game involves an element of financial risk
                                    and may be addictive. Please play responsibly
                                    at your own risk.
                                </p>
                            </div>
                            <div className='footer-hr'></div>
                            <div className="text-center py-3 footer-links">
                                <p >Copyright © {window.location.hostname}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {show_whatsapp &&
                <div className='w-[390px] fixed bottom-0 z-9999'>
                    <div class="whatsapp-badge animate-bounce" id="whatsapp-badge" style={{ transform: `translate(${position.x}px, ${position.y}px)`, }} >
                        {/* <div className='move-icn' onMouseDown={onMouseDown}
                            onTouchStart={onTouchStart}>
                            <svg width="38" height="22" viewBox="0 0 38 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M37.146 9.92318L33.7426 7.23738C33.4102 6.975 32.9572 6.92577 32.5759 7.11052C32.1949 7.2952 31.9529 7.68149 31.9529 8.10495V9.68555H20.3563V5.9065H21.9371C22.3605 5.9065 22.7468 5.66451 22.9315 5.28348C23.1163 4.90245 23.067 4.44937 22.8047 4.11686L20.1188 0.713423C19.9093 0.447842 19.5896 0.292969 19.2513 0.292969C18.913 0.292969 18.5933 0.447907 18.3838 0.713423L15.698 4.11686C15.4356 4.4493 15.3864 4.90239 15.5711 5.28348C15.7559 5.66464 16.1421 5.9065 16.5656 5.9065H18.146V9.68555H6.54946V8.10483C6.54946 7.68136 6.30747 7.29514 5.92644 7.11039C5.54528 6.92564 5.09232 6.97488 4.75981 7.23725L1.35634 9.92318C1.09076 10.1327 0.935883 10.4524 0.935883 10.7907C0.935883 11.129 1.09082 11.4487 1.35634 11.6582L4.75981 14.344C4.9586 14.5009 5.20065 14.5816 5.4445 14.5816C5.60842 14.5816 5.77329 14.5451 5.92631 14.4709C6.30734 14.2863 6.54933 13.9 6.54933 13.4765V11.8958H18.146V15.6749H16.5653C16.1418 15.6749 15.7556 15.9169 15.5708 16.298C15.3861 16.679 15.4353 17.1321 15.6977 17.4646L18.3835 20.868C18.5931 21.1336 18.9128 21.2885 19.2511 21.2885C19.5893 21.2885 19.909 21.1335 20.1186 20.868L22.8044 17.4646C23.0668 17.1322 23.116 16.6791 22.9313 16.298C22.7465 15.9168 22.3603 15.6749 21.9368 15.6749H20.3563V11.8958H31.9529V13.4765C31.9529 13.9 32.1949 14.2862 32.5759 14.4709C32.7291 14.5452 32.8939 14.5816 33.0577 14.5816C33.3017 14.5816 33.5436 14.5009 33.7424 14.344L37.1459 11.6582C37.4115 11.4487 37.5664 11.129 37.5664 10.7907C37.5664 10.4524 37.4115 10.1327 37.146 9.92318Z" fill="#F5A623" />
                            </svg>
                        </div> */}
                        <div className='close-icn' onClick={() => setShowWTSP(!show_whatsapp)}>
                            <svg width="9" height="9" viewBox="0 0 9 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.32578 8.09247L1.6432 1.40918M1.64392 8.09247L8.3265 1.40918" stroke="#F5A623" stroke-width="1.34014" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                        <a href={wplink}>
                            <img src={Images.WHATSAPP_M} width={150} height="50" alt="" />
                        </a>
                    </div>
                </div>
            }
        </React.Fragment>
    )
}

export default Footer